import React, { Dispatch, SetStateAction } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NoResults from "src/app/components/NoResultsScreen/NoResultsScreen";
import { Button } from "src/app/components/Button/Button";
import noFilteredResultsImg from "src/images/no-publications-found.svg";
import { GalleryFilters } from "src/types";
import { getFiltersCounter } from "../GalleryFiltersDropdown/GalleryFiltersDropdown";

interface Props {
  filters: GalleryFilters;
  setFilters: Dispatch<SetStateAction<GalleryFilters>>;
  initialFilters: GalleryFilters;
}

function GalleryNoItemsFound(props: Props) {
  const { filters, setFilters, initialFilters } = props;

  const areFiltersApplied = getFiltersCounter(filters) > 0;

  const getTitle = () => {
    if (areFiltersApplied) {
      return (
        <IDHFormattedMessage
          id="ws_no_publications_found"
          defaultMessage="No publications found"
        />
      );
    }

    return (
      <IDHFormattedMessage
        id="ws_no_publications_to_display"
        defaultMessage="No publications to display"
      />
    );
  };

  const getSubtitle = () => {
    if (areFiltersApplied) {
      return (
        <IDHFormattedMessage
          id="ws_this_creator_doesnt_have_publications_for_the_selected_filters"
          defaultMessage="This creator doesn’t have publications for the selected filters."
        />
      );
    }

    return (
      <IDHFormattedMessage
        id="we_havent_found_any_publications_for_this_creator_yet"
        defaultMessage="We haven’t found any publications for this creator yet."
      />
    );
  };

  const renderButton = () => {
    if (areFiltersApplied) {
      return (
        <Button
          size="large"
          variant="blue"
          onClick={() => setFilters(initialFilters)}
        >
          <IDHFormattedMessage
            id="ws_clear_filters"
            defaultMessage="Clear filters"
          />
        </Button>
      );
    }

    return undefined;
  };

  return (
    <NoResults
      title={getTitle()}
      subtitle={getSubtitle()}
      imgUrl={noFilteredResultsImg}
      bottomContent={renderButton()}
      mode="vertical"
    />
  );
}

export default GalleryNoItemsFound;
